import http from '../http-common'

class SharedService {
  uploadImage (data) {
    // eslint-disable-next-line no-undef
    return http.post('/api/shared/save-image', data).catch(e => e.response)
  }

  imageProxy(url) {
    return http.get(`/api/shared/proxy-image?url=${url}`).catch(e => e.response)
  }

  videoProxy(seat_id, start, end) {
    return http.get(`/api/shared/proxy-video?id=${seat_id}&start=${start}&end=${end}`).catch(e => e.response)
  }
}

export default new SharedService()
